export default {
    project: '项目',
    save: '保存',
    confirm: '确认',
    cancel: '取消',
    update: '更新',
    edite: '修改',
    delete: '删除',
    tips: '提示',
    success: '成功',
    addsucc: '新增成功',
    updatesucc: '修改成功',
    deletesucc: '删除成功',
    main: {
        language: {
            buttonTitle: '选择语言',
            switchSuccessTip: '更改语言成功！'
        },
        webparts: {
            project: {
                finish: '完成',
                project: '项目',
                errorRate: '错误率',
                task: '任务',
                normal: '正常',
                late: '迟到',
                leaveEarly: '早退',
                appeal: '申述'
            }
        },
        logout: '退出登录',
        setting: '设置',
        theme: '主题',
        sidebar: '侧边栏',
        sidebarSwitch: '展开',
        right: '版权所有',
        mail: '收件箱',
        message: '通知',
    },
    setting: {
        menuname: '快捷菜单 | 应用统计',
        shortcut: '快捷菜单',
        application: '应用统计',
        status: '状态',
        operate: '操作',
        update: '修改',
        delete: '删除',
        disable: '停用',
        able: '启用',
        newshortcut: '新增快捷菜单',
        newapplication: '新增应用统计',
        editeshortcut: '编辑快捷菜单',
        editeapplication: '编辑应用统计',
        opentype1: '应用内打开',
        opentype2: '外部窗口',
        target: '打开方式',
        link: '链接地址',
        avater: '上传图标',
        shortcutname: '快捷菜单名称',
        nameplace: '点击后面图标进行英文设置',
        linkplace: '请输入链接地址',
        codeplace: '请输入标识，仅支持英文',
        translateplace: '请输入',
        translatetitle: '添加翻译字段',
        flag: '标识',
        content: '内容',
        appliactionname: '应用模块名称',
        phototype: '上传图片只能是 JPG、PNG、GIF、SVG 格式!',
        photosize: '上传图片大小不能超过 2MB!',
        validshotname: '请输入菜单名称',
        validappname: '请输入应用名称',
        validnamelen: '不能超过 20 个字符',
        validupload: '请上传图标',
        validlink: '请输入链接地址',
        validtrans: '请输入内容',
        validflag: '请输入应用标识',
        validenglish: '请输入正确的标识，仅支持英文',
        tipsdesc: '是否继续删除操作?',
        chinese: '中文',
        english: '英文',
        done:'完成',
        draft:'草稿',
        waiting:'审核中',
    }
}
